export default{
    info:"yige xigua",
    smelting:false,
    urls:"http://192.168.0.156:8888/",
    smeltData:"",
    actualAmount:"",
    smeltPlants:"",      //中左边冶炼厂数据
    smeltPSele:"" ,      //冶炼厂选中的那个

    msg:"",             //接受来自子组件的数据

    i:1,                //
    searchType:"",      //查询数据是需要的类型
    pageNo:1,          //当前页码
    pageAll:1,          //总数据页码
    infoDate:false,     //日期默认不显示
    smeltInfo:false,        //默认为false冶炼厂有数据以后定义为true，再次点击冶炼厂之后不再清空数据
    token:"",
    capital:"",             //底部四个数据
    fontH:"",
    fresh:false,
    noFresh:true,          //首页顶部图片刷新
    innerHeight:"",          //做兼容用的
    isShow:false,              //为了将来首页左边导航栏更新+++

    smeltPSele0:"给自组建传递数据***data",
}







// WEBPACK FOOTER //
// ./src/homeDataMethods/homeData.js